<script lang="ts">
import { useEditorStore } from '@/stores/editorStore';
import { useFileStore } from '@/stores/fileStore';

export default {
  name: "LoaderProgress",
  setup() {
    const editorStore = useEditorStore();
    const fileStore = useFileStore();
    return { editorStore, fileStore };
  },
  computed: {
    progress(): number {
      return this.editorStore.progress || this.fileStore.progress || 0;
    },
    dashOffset(): number {
      const circumference = 2 * Math.PI * 45;
      return circumference * (1 - this.progress / 100);
    }
  }
};
</script>

<template>
  <div class="loader-block">
    <div class="upload">
      <div class="upload-container">
        <svg width="100" height="100" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" stroke="#DCE7FF" stroke-width="5" fill="none" />
          <circle
            cx="50"
            cy="50"
            r="45"
            stroke="#325AFF"
            stroke-width="6"
            fill="none"
            stroke-dasharray="283"
            :stroke-dashoffset="dashOffset"
            stroke-linecap="round"
            transform="rotate(-90 50 50)"
            class="progress-circle"
          />
        </svg>
        <p class="upload-text">{{ progress }}%</p>
      </div>
      <div class="upload-title">{{ $t('loader.loading') }}</div>
    </div>
  </div>
</template>

<style scoped>
.loader-block{
  z-index: 11;
  position: fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
}
.upload{
  display: flex;
  flex-direction: column;
}
.upload-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.upload-text {
  position: absolute;
  margin: auto;
  font-size: 1.4rem;
  top:calc(50% - .6rem);
}
.upload-title {
  margin-top: 1rem;
  font-size: 1.4rem;
}
.progress-circle {
  transition: stroke-dashoffset 0.2s ease-in-out;
}
</style>